module.exports = __webpack_public_path__ + "img/jobs-by-category.95aa6710.png";